import { useState } from 'react'

/*
	apollo-client's fetchMore does not trigger setting error in Query component,
	and if something goes wrong it sends Query component in infinite loading state,
	thus we need this HOC
*/

const useFetchMoreState = () => {
	const [fetchMoreError, setFetchMoreError] = useState()
	const handleFetchMore = fetchMore => async (...args) => {
		try {
			setFetchMoreError()
			await fetchMore(...args)
		} catch(e) {
			setFetchMoreError(e)
		}
	}
	const renderPropsEnhance = ({ fetchMore, loading, networkStatus, error, ...queryProps }) => {
		return {
			...queryProps,
			networkStatus: fetchMoreError ? 8 : networkStatus,
			loading: fetchMoreError ? false : loading,
			error: fetchMoreError ? {
				...!!error && error,
				fetchMoreError
			} : error,
			fetchMore: handleFetchMore(fetchMore)
		}
	}
	return [renderPropsEnhance]
}

export default useFetchMoreState
